import React from 'react';
import { Box, CircularProgress } from '@mui/material';

export const Loading = () => (
  <Box display="flex" justifyContent="center" alignItems="center" mt="10em">
    <CircularProgress size="5em" />
  </Box>
);
